var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert-a",
    x1: "0%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert-b",
    x1: "0%",
    x2: "101.131%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert-a)",
    d: "M32 14.451L8.57 50h46.86L32 14.451zM58.956 49.9A2 2 0 0 1 57.286 53H6.714a2 2 0 0 1-1.67-3.1L30.33 11.533a2 2 0 0 1 3.34 0l25.286 38.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert-b)",
    d: "M32 46a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0-20a2.602 2.602 0 0 1 2.576 2.97L33.14 39.01a1.153 1.153 0 0 1-2.282 0l-1.435-10.04A2.602 2.602 0 0 1 32 26z"
  }))));
};
export default SvgAlert;